var _path, _path2, _circle, _circle2, _circle3, _circle4, _rect, _rect2, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphicDesignIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6744 9H19.6461C18.8218 9 18.082 9.50569 17.7826 10.2737L12.2969 24.3479C12.1066 24.8361 12.1155 25.3795 12.3217 25.8612L14.4952 30.9397C14.6857 31.3848 14.7083 31.8839 14.5587 32.3444L13.8968 34.3822C13.4771 35.6744 14.4403 37 15.799 37H19.6744M19.3256 9H19.3539C20.1782 9 20.918 9.50569 21.2174 10.2737L26.7031 24.3479C26.8934 24.8361 26.8845 25.3795 26.6783 25.8612L24.5048 30.9397C24.3143 31.3848 24.2917 31.8839 24.4413 32.3444L25.1032 34.3822C25.5229 35.6744 24.5597 37 23.201 37H19.3256",
    stroke: "white",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7725 3.29312C9.28195 5.00318 3.57293 11.7502 3 20M22.5709 3C30.8062 4.01581 37.2995 11.0369 38 19.7953",
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 4,
    r: 1.5,
    stroke: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 1.5,
    stroke: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 23.5,
    r: 3,
    stroke: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 3.5,
    r: 3,
    stroke: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 19.5,
    width: 5,
    height: 5,
    rx: 0.5,
    transform: "rotate(90 5.5 19.5)",
    stroke: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39.5,
    y: 19.5,
    width: 5,
    height: 5,
    rx: 0.5,
    transform: "rotate(90 39.5 19.5)",
    stroke: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 3.5,
    x2: 16,
    y2: 3.5,
    stroke: "white"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 3.5,
    x2: 35,
    y2: 3.5,
    stroke: "white"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 31.5,
    x2: 24,
    y2: 31.5,
    stroke: "white"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 19.5,
    y1: 9,
    x2: 19.5,
    y2: 21,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicDesignIcon);
export default __webpack_public_path__ + "static/media/graphicDesignIcon.99b61880234cb8c642bdeb6870d94512.svg";
export { ForwardRef as ReactComponent };